/**
 * --------------------------------------------------------------
 * Harapan nya modul ini digunakan global
 * artinya bisa digunakan untuk agent maupun custmer
 * SERVER_TIME : manipulate server time
 * LOG_DEMO : menampilkan log jika VUE_APP_MODE == demo
 * --------------------------------------------------------------
 */
import { appMode } from "@/common/config";
export const SERVER_TIME = "ServerTime";
export const LOG_DEMO = "printDemo";
export const INCREMENT_READ_BY_CRON = "incrementReadByCRON";

export default {
  state: {
    /**
     * --------------------------------------------------------------
     * state untuk listen waktu server menggunakan cron get dari firebase
     * time : time listen server others/server-time
     * diff : selisih time server dan local
     * isPlus : minus / plus (base on reload req api /config/customer)
     * countRefresh : berapa kali refresh init listen firebase if > 5 show swal
     * --------------------------------------------------------------
     */
    _server_time: {
      time: 0,
      diff: 0,
      isPlus: true,
      countRefresh: 0,
    },

    /**
     * --------------------------------------------------
     * increment trigger when api/message/read update by cronjob
     * --------------------------------------------------
     */
    _read_message_by_cronjob: 0,
  },
  getters: {
    getVuexGeneral(state) {
      return state;
    },
    getIncrementReadByCRON(state) {
      return state._read_message_by_cronjob;
    },
  },
  actions: {
    [SERVER_TIME]({ commit }, params) {
      commit(SERVER_TIME, params);
    },
    [LOG_DEMO](commit, message) {
      if (appMode === "demo") {
        if (typeof message !== "string") {
          console.warn(`[rw:info] : `, message);
        } else {
          console.warn(`[rw:info] : ${message}`);
        }
      }
    },
  },
  mutations: {
    [SERVER_TIME](state, params) {
      if (params && typeof params === "object") {
        state._server_time = {
          ...state._server_time,
          ...params,
        };
      }
    },
    [INCREMENT_READ_BY_CRON](state) {
      state._read_message_by_cronjob++;
    },
  },
};
